const STORE_ROCKET_WIDGET_SRC = 'https://cdn.storerocket.io/js/widget.js';
const urlParams = new URLSearchParams(window.location.search);
let preSelectedStoreFlowStarted = false;
window.ElevarDataLayer = window.ElevarDataLayer || [];
let storeAcuityLocale;

function injectStoreRocketWidget() {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = STORE_ROCKET_WIDGET_SRC;
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(script, firstScript);
}

function handleStoreRocketCTA(element) {
  if (!element.href.startsWith('https://{')) return;

  // Replace single quotes ➜ double quotes so JSON.parse works
  const schedulerData = element.href.replace('https://', '').replace(/'/g, '"');

  if (element.hasAttribute('data-event-listener-attached')) return;
  element.setAttribute('data-event-listener-attached', 'true');

  element.addEventListener('click', (e) => {
    e.preventDefault();
    try {
      const data = JSON.parse(schedulerData);
      window.bookAcuityFitting(data, element, false)
    } catch (err) {
      console.error('StoreRocket handler: failed to parse JSON from href', err);
    }
  });

  window.ctaTranslatorAndFilterApply(element);

  /* If URL param ?startFittingFlow=true is present, kick off the flow once after the first search results appear. */
  const startFittingFlow = urlParams.get('startFittingFlow');
  if (startFittingFlow === 'true' && !preSelectedStoreFlowStarted) {
    waitForElement('.storerocket-result-button', () => {
      window.startFittingFlow();
      preSelectedStoreFlowStarted = true;
    });
  }
}

function dropdownFilterOptionsTranslationsHandler(el) {
  const urlParamFilters = urlParams.get('filteredStores');
  window.filterOptionsTranslateAndPreSelect(el, urlParamFilters);
}

function storeCardFilterTypeTranslationHelper(el) {
  window.storeCardLocalization(el);
}

function waitForElement(selector, callback, timeout = 5000) {
  const obs = new MutationObserver(() => {
    if (document.querySelector(selector)) {
      obs.disconnect();
      callback();
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => obs.disconnect(), timeout);
}

document.addEventListener('DOMContentLoaded', () => {
  injectStoreRocketWidget();

  elementReady('.storerocket-overlay-details-custom-ctas-item', false, handleStoreRocketCTA).then(handleStoreRocketCTA);
  elementReady('.storerocket-result-button',                  false, handleStoreRocketCTA).then(handleStoreRocketCTA);

  elementReady('.storerocket-overlay-filters-list',     false, dropdownFilterOptionsTranslationsHandler);
  elementReady('.storerocket-result-item-filter-name',  false, storeCardFilterTypeTranslationHelper);
  elementReady('.storerocket-overlay-filters-item',     false, storeCardFilterTypeTranslationHelper);
});

window.addEventListener('message', function(event) {
  // Check if the message is from Acuity Custom Conversion Tracking
  if (event.data && event.data.event === 'acuityConversion') {
    window.ElevarDataLayer.push({
      event: 'dl_appointment_booking',
      locationName: storeName,
      loggedIn: loggedIn,
      fittingExperience: event.data.appointmentType,
      appointmentDate: event.data.appointmentDate,
      currencyCode: Shopify.currency.active,
      ecommerce: {
        purchase: {
          actionField: {
            id: event.data.bookingID,
            affiliation: 'PXG',
            revenue: '0',
            tax: '0',
            shipping: '0',
            coupon: null,
            newCustomer: loggedIn,
            shippingMethod: 'NA',
            paymentMethod: 'NA',
          },
          products: [
            {
              name: event.data.appointmentType,
              id: event.data.bookingID,
              price: '0.00',
              variant: null,
              brand: 'PXG',
              quantity: 1,
              category: 'Fitting',
              coupon: null,
              dimension3: 'Web',
              dimension4: storeAcuityLocale,
              appointmentDate: event.data.appointmentDate
            }
          ]
        }
      }
    });
  }
});
